import moment from "moment";

// Routes that render without the app header.
export const PATH_ARRAYS = ["/auth", "/login"];

export const statusColors = {
  accepted: "blue",
  dispatched: "primaryColor",
  cancelled: "tileRedColor",
  declined: "tileRedColor",
  rejected: "tileRedColor",
  delivered: "green",
  returned: "secondaryGray",
  refunded: "primaryColor",
};

export const radiusInMeters = 10000;

export const dateFormat = "MM/DD/YYYY";
export const dashboardDateFormat = "DD/MM/YYYY";
export const timeFormat = "HH:mm:ss";
export const filterDateFormat = "YYYY-MM-DD";
export const NOTIFICATION_TIME = 4;
export const dateTimeFormat = "DD/MM/YYYY HH:mm";
export const listDateFormat = "DD-MM-YYYY";

export const SECONDS_BEFORE_TOKEN_EXPIRY = 20;

export const CAM_IMG_PATH = "/assets/icons/camera-place-holder.svg";

export const VOLUME_STEP = 0.5;
export const PRICE_STEP = 50;

export const VOLUME_UNIT = "kg";
export const pKG_VOLUME = "pKG";

export const MIN_DELIVERY_DATE = new Date();
export const MAX_DELIVERY_DATE = new Date(moment().add(30, "days"));
export const UTC_TIME_FORMAT = "hh:mm:ss A";
export const UTC_MINUTE_FORMAT = "hh:mm A";
export const CARD_EXPIRY_VALIDATION = "MMYYYY";

export const WALLET_TOPUP_PURPOSE = "wallet.topup";
export const RESERVATION_EXPIRY_MINUTES = 11;

/**
 * Stand-in for `/ip-info`, which returns 404 on the Sayagie backend.
 *
 * It only ever supplied a default country for the phone input and a map
 * centre before the browser grants geolocation, so a static default is an
 * acceptable substitute. Accra, since dev is GHS-only.
 */
export const FALLBACK_IP_INFO = {
  countryCode: "GH",
  location: { latitude: 5.6037, longitude: -0.187 },
};
